export default {
  '内容形式':'Content Type',
  '发布时间':'Publish Time',
  '请输入标题搜索':'Enter title to search',
  '封面图':'Cover Image',
  '备课内容':'Teaching Materials',
  '备课视频':'Teaching Video',
  '发布设置':'Publish Settings',
  '支持jpg':'Upload Cover Image (JPG/JEPG/PNG, 4:3 ratio, max 5MB)',
  '请上传封面图':'Upload Cover Image',
  '请上传备课视频':'Upload Teaching Video',
  '支持上传mp4格式':'Upload Video (MP4 format, max 500MB)',
  '链接地址':'Link URL',
  '视频描述':'Video Description',
  '标题不可为空':'Title cannot be empty',
  '内容不可为空':'Content cannot be empty',
  '确认要停用':'Confirm Deactivation',
  '本机构资源空间已不足，请及时联系运营人员':'Insufficient resource space for this organization, please contact the operator promptly',
}